import { ResourceVendor } from '../../__generated__/graphql';

const LOCKS_WITH_CODES = new Map([
  [ResourceVendor.Schlage, true],
  [ResourceVendor.Yale, true],
]);

export default LOCKS_WITH_CODES;
